import { P2GButton, P2GDialog, P2GIcon, P2GText, P2GTooltip, SvgDuplicate } from '@parcel2go/core-ui';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Loading from '~/components/core/progress/loading';
import { TranslationNamespaces } from '~/lib/constants';

type prop = {
  onDuplicate: (id: string) => void;
  name: string;
  index: number;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
};

export const DuplicateItem = ({ onDuplicate, name, index, size }: prop) => {
  const { t } = useTranslation([TranslationNamespaces.CHECKOUT]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (showModal) {
      const timer = setTimeout(() => setLoading(false), 750);
      return () => clearTimeout(timer);
    }
  }, [showModal]);

  return (
    <>
      <P2GTooltip title={t('DUPLICATE_BASKET_ITEM_TOOLTIP', { defaultValue: 'Duplicate' })}>
        <P2GIcon
          size={size}
          palette="primary"
          dataTestId={`basket-item-header-duplicate-${index}`}
          onClick={() => setShowModal(true)}
        >
          <SvgDuplicate />
        </P2GIcon>
      </P2GTooltip>
      <P2GDialog
        dataTestId={`basket-item-dialog-duplicate-${index}`}
        title={t(loading ? 'DUPLICATE_BASKET_ITEM_DIALOG_HEADER_LOADING' : 'DUPLICATE_BASKET_ITEM_DIALOG_HEADER', {
          defaultValue: loading ? 'Duplicating Order' : 'Order Duplicated'
        })}
        content={
          loading ? (
            <Loading p={0} />
          ) : (
            <P2GText component="p">
              {t('DUPLICATE_BASKET_ITEM_DIALOG_CONTENT', {
                defaultValue: 'Please add a delivery address to confirm this order.'
              })}
            </P2GText>
          )
        }
        open={showModal}
        onClose={() => onDuplicate(name)}
        actions={[
          <P2GButton onClick={() => onDuplicate(name)} variant="primary">
            {t('DUPLICATE_BASKET_ITEM_DIALOG_BUTTON', { defaultValue: 'Add Delivery Address' })}
          </P2GButton>
        ]}
      />
    </>
  );
};
